const NAMES = ["MOTS-C", "RT-3A", "BPC-157", "TB-500"];
const MG = ["5 mg", "10 mg", "20 mg", "40 mg"];

const CSS = `
.sfc *{margin:0;padding:0;box-sizing:border-box}
.sfc-card{width:293px;flex:0 0 293px;background:#FFFFFF;border:1px solid #E7D8C9;border-radius:4px;padding:14px}
.sfc-img{width:263px;height:200px;background:#FFFFFF}
.sfc-name{margin-top:12px;height:25px;font-family:'Cormorant Garamond',serif;font-size:23px;font-weight:600;line-height:25px;color:#811329}
.sfc-mg{margin-top:10px;display:flex;gap:6px;flex-wrap:nowrap;width:263px}
.sfc-f{display:flex;align-items:center;justify-content:center;gap:6px;font-family:'Manrope',sans-serif;font-size:10px;font-weight:600;line-height:normal;border-radius:10px;border:1px solid;white-space:nowrap;cursor:default}
.sfc-pill{flex:1 1 0;height:20px;background:#FBF8F3;border-color:#DDD0C4;color:#2A2A2A}
.sfc-pill.sel{background:#F2DEC9;border-color:#C58E4B}
.sfc-div{margin-top:12px;width:263px;height:1px;background:#E6C8AB}
.sfc-btns{margin:12px auto 0;width:258px;display:grid;grid-template-columns:125px 125px;gap:8px}
.sfc-btn{width:125px;height:20px}
.sfc-b3{background:#F3DFCA;border-color:#C4884C;color:#8A1020}
.sfc-b10{background:#FAF6F1;border-color:#DCCFC4;color:#1C2452}
.sfc-add{background:#811329;border-color:#811329;color:#FFFFFF}
.sfc-coa{background:#FAF6F1;border-color:#DCCFC4;color:#811329}
`;

const Bag = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" /><path d="M3 6h18" /><path d="M16 10a4 4 0 0 1-8 0" /></svg>
);
const Doc = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" /><path d="M14 2v4a2 2 0 0 0 2 2h4" /><path d="M16 13H8" /><path d="M16 17H8" /><path d="M10 9H8" /></svg>
);

const Card = ({ name, i }) => (
  <div className="sfc-card" data-testid={`preview-supply-card-${i}`}>
    <div className="sfc-img" />
    <div className="sfc-name" data-testid={`preview-supply-card-name-${i}`}>{name}</div>
    <div className="sfc-mg">
      {MG.map((m, k) => <div key={m} className={`sfc-f sfc-pill${k === 3 ? " sel" : ""}`}>{m}</div>)}
    </div>
    <div className="sfc-div" />
    <div className="sfc-btns">
      <div className="sfc-f sfc-btn sfc-b3">3 VIALS</div>
      <div className="sfc-f sfc-btn sfc-b10">10 VIALS</div>
      <div className="sfc-f sfc-btn sfc-add"><Bag />ADD · $100</div>
      <div className="sfc-f sfc-btn sfc-coa"><Doc />COA</div>
    </div>
  </div>
);

export default function PreviewSupplyFourCards() {
  return (
    <div className="sfc" style={{ background: "#FFFFFF", minHeight: "100vh", padding: "40px 0" }} data-testid="preview-supply-four-cards">
      <style>{CSS}</style>
      <div style={{ display: "flex", flexWrap: "nowrap", gap: "13px", justifyContent: "center", alignItems: "flex-start" }} data-testid="preview-supply-row">
        {NAMES.map((n, i) => <Card key={n} name={n} i={i} />)}
      </div>
    </div>
  );
}
